<template>
  <div>
    <div
      v-if="isButtonActive"
    >
      Belge Yükleme işlemi için partner.trendyol.com'u kullanınız.
    </div>
    <div
      v-else
    >
      Belge onay sürecinde
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocStatus',
  props: {
    product: {
      type: Object,
      default: () => ({
        approved: false,
      }),
    },
  },
  computed: {
    permissionStatus () {
      if (this.product.docNeeded && this.product.brandId && this.product.pimCategoryId) {
        return this.product.relatedPermission ? this.product.relatedPermission.permissionStatus : '';
      } else {
        return '';
      }
    },
    isButtonActive () {
      return this.permissionStatus === 'REJECTED' || this.permissionStatus === 'PENDING_DOC';
    },
  },
};
</script>
